import React from 'react';

import LandingPageTemplate from './LandingPageTemplate';

export default function LaboratoireDeMusiqueChromé() {
const title = "Laboratoire De Musique Chromé";
const keywords = "générateur de paroles, générateur de musique, composition de chansons, outil de composition, application de composition, plateforme de composition, logiciel de composition, outil de composition, outils de composition, site web de composition, comment écrire une chanson";
const description = "Apprenez à composer des chansons avec l'IA au Laboratoire de Musique Chromé";
const longDescription = "Le Laboratoire de Musique Chromé est une plateforme de composition qui utilise l'IA pour vous aider à écrire des paroles et des mélodies musicales rapidement. C'est votre assistant personnel de composition, adapté à vos goûts et besoins musicaux personnels!";
const h1 = "Apprenez à composer une chanson avec le pouvoir de l'IA.";
const h2 = "Révolutionnez votre processus de création musicale avec nos paroles générées par l'IA.";
const sectionHeader = "Votre Compagnon Ultime de Composition";
const featureTitle1 = "Créativité sans limites";
const featureTitle2 = "Votre assistant personnel de composition";
const featureTitle3 = "Dictionnaire intelligent intégré";
const featureTitle4 = "Composez dans toutes les langues";
const featureParagraph1 = "Une inspiration sans fin pour la composition vous attend avec un approvisionnement continu d'idées originales et de mélodies. L'IA peut écrire sur n'importe quel sujet et générer de la musique de tout genre";
const featureParagraph2 = "Collaborez avec notre partenaire de composition IA pour créer la chanson parfaite. Une fois que vous avez les paroles et la musique, vous pouvez interagir avec l'IA pour concrétiser votre vision musicale.";
const featureParagraph3 = "La plateforme est équipée d'un dictionnaire intelligent intégré qui vous aide à trouver toutes sortes de mots associés pour fournir de l'inspiration et vous aider à compléter vos paroles.";
const featureParagraph4 = "Avec plus de 100+ langues disponibles, vous pouvez apprendre à écrire des paroles de chansons dans n'importe quelle langue!";
const faq1 = "Ai-je les droits d'auteur?";
const faq2 = "Le but de la plateforme est-il de composer entièrement mes chansons pour moi?";
const faq3 = "Comment la plateforme m'aide-t-elle à surmonter le blocage de l'écrivain?";
const faq4 = "Comment la plateforme stimule-t-elle mon processus de composition?";
const faqa1 = "Oui ! Le Laboratoire de Musique Chromé est 100% libre de droits, donc vous conservez tous les droits sur la musique et les paroles que vous créez sur cette plateforme.";
const faqa2 = "Non, le but de notre plateforme est de vous fournir une source sans fin d'inspiration et d'aider à surmonter le blocage de l'écrivain. Alors que l'IA est capable de générer des ensembles complets de paroles et de mélodies musicales, nous vous encourageons à les utiliser comme point de départ et à ajouter votre touche personnelle. L'IA est là pour assister et inspirer, et non pour remplacer votre créativité.";
const faqa3 = "Le blocage de l'écrivain peut être une expérience frustrante et démoralisante pour tout compositeur. Mais avec notre plateforme, vous n'aurez jamais à vous soucier de manquer d'idées. Entrez simplement votre thème et style désirés, et l'IA vous fournira un flux continu d'idées créatives et originales avec lesquelles travailler. Cela peut aider à démarrer votre processus de composition et vous remettre sur les rails.";
const faqa4a = "Notre plateforme est conçue pour vous fournir un approvisionnement sans fin d'idées et de suggestions basées sur vos préférences stylistiques choisies, vous donnant la liberté d'expérimenter et d'essayer quelque chose de nouveau.";
const faqa4b = "";
const quote1 = "C'est un changement de jeu, m'a vraiment aidé à écrire ma première chanson";
const quote2 = "Produit brillant, je le recommanderais à quiconque veut apprendre à écrire une chanson";
const quote3 = "Service client excellent, vraiment cool pour apprendre à écrire une chanson";
return (

<>
<LandingPageTemplate
title={title}
keywords={keywords}
description={description}
longDescription={longDescription}
h1={h1}
h2={h2}
sectionHeader={sectionHeader}
featureTitle1={featureTitle1}
featureTitle2={featureTitle2}
featureTitle3={featureTitle3}
featureTitle4={featureTitle4}
featureParagraph1={featureParagraph1}
featureParagraph2={featureParagraph2}
featureParagraph3={featureParagraph3}
featureParagraph4={featureParagraph4}
faq1={faq1}
faq2={faq2}
faq3={faq3}
faq4={faq4}
faqa1={faqa1}
faqa2={faqa2}
faqa3={faqa3}
faqa4a={faqa4a}
faqa4b={faqa4b}
quote1={quote1}
quote2={quote2}
quote3={quote3}
/>
</>
);
}
